export default __webpack_public_path__ + "static/media/wildlife07.9584fd0d.png";